import script from "./UPersonData.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPersonData.vue?vue&type=script&setup=true&lang=ts"

import "./UPersonData.vue?vue&type=style&index=0&id=bb92e74e&lang=css"

const __exports__ = script;

export default __exports__